import * as queryString from 'query-string'
import React, { useState } from 'react'
import { sendSetPasswordRequest } from '../../../clients/userPool'
import { StyledTextField } from '../../../theme/Global'
import AuthenticationForm from './AuthenticationForm'
import { CustomParagraphBlock } from './styles'
import { hasEmptyInputs } from './helper'

const getConfirmationCode = (props) => {
  const parsedQueryString = queryString.parse(props.location.search)
  return parsedQueryString.code || ''
}

const getUsername = (props) => {
  const parsedQueryString = queryString.parse(props.location.search)
  return parsedQueryString.username || ''
}

const ResetPasswordComponent = (props) => {
  const [confirmationCode, setConfirmationCode] = useState(getConfirmationCode(props))
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [helpIconAnchorEl, setHelpIconAnchorEl] = useState(null)
  const [status, setStatus] = useState('idle')
  const [submitError, setSubmitError] = useState(false)
  const [errorText, setErrorText] = useState('')

  const success = () => {
    props.history.push('/')
  }

  const setErrorMessage = (error) => {
    switch (error.code) {
      case 'PasswordMismatchException':
        setErrorText('The passwords you entered do not match. Please re-enter your new password.')
        break
      case 'CodeMismatchException':
        setErrorText('The Confirmation Code you entered is invalid. Please request a new code.')
        break
      case 'ExpiredCodeException':
        setErrorText('The Confirmation Code you entered is expired. Please request a new code.')
        break
      case 'InvalidParameterException':
      case 'InvalidPasswordException':
        setErrorText('The new password you entered does not meet the requirements listed. Please enter a valid password.')
        break
      default:
        setErrorText('An unexpected error has occurred. Please try resetting your password again or contact your Account Manager if the issue persists.')
        break
    }
  }
  const fail = (err) => {
    setErrorMessage(err)
    setStatus('idle')
    setSubmitError(true)
  }

  const submit = () => {
    if (!hasEmptyInputs(inputComponents)) {
      if (password !== confirmPassword) {
        fail({ code: 'PasswordMismatchException' })
      } else {
        setStatus('attempting')
        sendSetPasswordRequest(getUsername(props), confirmationCode, password, success, fail)
      }
    }
  }

  const submitOnEnter = (event) => {
    if (event.charCode === 13) {
      submit()
    }
  }

  const onCloseError = (event) => {
    setErrorText('')
    setSubmitError(false)
  }

  const inputComponents = [
    <StyledTextField
      inputProps={{ 'data-testid': 'confirmation-code-input', autocomplete: 'one-time-code' }}
      name="confirmationCode"
      fullWidth
      label="Confirmation Code"
      onChange={(e) => setConfirmationCode(e.target.value)}
      onKeyPress={submitOnEnter}
      value={confirmationCode}
    />,
    <StyledTextField
      inputProps={{ 'data-testid': 'password-input', autocomplete: 'new-password' }}
      name="password"
      fullWidth
      label="Password"
      onChange={(e) => setPassword(e.target.value)}
      type="password"
      onKeyPress={submitOnEnter}
      value={password}
    />,
    <StyledTextField
      inputProps={{ 'data-testid': 'confirm-password-input', autocomplete: 'new-password' }}
      name="confirmPassword"
      fullWidth
      label="Confirm Password"
      onChange={(e) => setConfirmPassword(e.target.value)}
      type="password"
      onKeyPress={submitOnEnter}
      value={confirmPassword}
    />,
  ]

  const message = (
    <CustomParagraphBlock>
      Passwords must be 8 characters in length and must include:
      <ul>
        <li>one uppercase letter</li>
        <li>one lowercase letter</li>
        <li>one number</li>
      </ul>
    </CustomParagraphBlock>
  )

  return AuthenticationForm({
    title: 'Set New Password',
    message,
    inputComponents,
    submit,
    helpIconAnchorEl,
    setHelpIconAnchorEl,
    onCloseError,
    status,
    submitError,
    errorText
  })
}

export default ResetPasswordComponent
